/**
 * Created by Marcus Zhao on 12/01/2020
 * -------------------------------------
 * Updated by Marcus 4/7/2022  support search address by tamale and google .and set address as a formatting.
 * Updated by Daniel Wang 8/5/2022 Handle some special country cases.
 */

import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { map, take } from 'rxjs/operators';
import { DefaultWordCites } from '@tamalelibs/constants/DefaultWorldCities.constants';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../redux';
import { ContactTemplateService } from '../../../contact-dialog-new/contact-template.service';
import { ContactTemplateControlValue } from '@tamalelibs/models/contact-template-control-value.model';
import { ChangeContactTemplateValueSet } from '@tamalelibs/redux/contact.actions';
import * as _lodash from 'lodash';
import { UUID } from 'angular2-uuid';
import { ReplaySubject } from 'rxjs';
import { ContactTemplateType, AddressValue, ContactAction } from '../../../contact-dialog-new/contact-dialog.model';
import { businessConstants } from '../../../../constants/business.constants';
import { Subscription } from 'rxjs';
import { DefaultCountryList, SpecialCountryList } from '@tamalelibs/constants/configuration.country.constants';
import { DefaultStateList } from '@tamalelibs/constants/configurationState.constants';
import { MapConfig } from '../../../tam-dashboard/tam-dashboard-map-tile/tam-dashboard-map/tam-dashboard-map.model';
import { Contact } from '@tamalelibs/models/contact.model';
import { EntityService } from '@tamalelibs/services/entity.service';

@Component({
    selector: 'tam-contact-address',
    templateUrl: './contact-address.component.html',
    styleUrls: ['./contact-address.component.scss'],
    standalone: false
})
export class ContactAddressComponent implements OnInit, OnDestroy {
    @Input() childConfig: any;
    @Input() valueChangeSubject: ReplaySubject<ContactTemplateControlValue>;

    config;
    connector = ' ';
    cityWidth = 146.5;
    hintContentStreet = '';
    hintContentCity = '';
    hintContentState = '';
    isCustom = false;
    isShowSearchAddress = false;
    mapConfig = new MapConfig();
    valueAddressType; // address dropdown
    valueCountry;  // address country
    valueStreet = '';
    valueStreet2 = '';
    valueCity = '';
    valueState;
    valueZip = '';
    valueAddressTypeList;
    valueCountryList;
    valueStateList;

    private _destroySubscriptions: Array<Subscription> = [];
    private _valueStateList = [];

    constructor(
        private _store: Store<AppState>,
        private _contactTemplateService: ContactTemplateService,
        private _entityService: EntityService) { }

    ngOnInit() {
        this.config = this.childConfig.config;
        this.mapConfig.isFromMap = false;
        this._initData();
        if (this.config.action === ContactTemplateType.EditContact || this.config.isSignature) {
            this._initEditValue();
        }
    }

    ngOnDestroy() {
        this._destroySubscriptions.forEach(item => item.unsubscribe());
    }

    /**
     * add dynamic control lyaout
     *
     * @param {*} event
     * @memberof ContactAddressComponent
     */
    clickAddCtrol(event) {
        this.updateContorlLayout(true);
    }

    /**
     * remove dynamic control layout
     *
     * @param {*} event
     * @memberof ContactAddressComponent
     */
    clickRemoveLayout(event) {
        this.updateContorlLayout(false);
    }

    updateContorlLayout(isAdd: boolean = true) {
        const newCtrlJson = _lodash.cloneDeep(this.childConfig);
        if (isAdd) {
            newCtrlJson.config.controlID = newCtrlJson.config.type + UUID.UUID();
            newCtrlJson.config.isCanDelete = true;
            const index = this.childConfig.dataSource.findIndex(item => item.name === newCtrlJson.config.defaultValue);
            if (index < this.childConfig.dataSource.length - 1) {
                newCtrlJson.config.defaultValue = this.childConfig.dataSource[index + 1].name;
            } else {
                newCtrlJson.config.defaultValue = this.childConfig.dataSource[0].name;
            }
            newCtrlJson.config.editValue = null;
        }
        this._contactTemplateService.actionSubject$.next({
            type: isAdd ? ContactAction.AddControl : ContactAction.RemoveControl,
            payload: {
                ctrlType: this.config.controlType,
                ctrl: newCtrlJson,
                secSName: this.config.secSName,
                controlID: this.config.controlID,
            }
        });
    }

    /**
     *
     * Address Type change
     * @param {*} item
     * @memberof ContactAddressComponent
     */
    changeValueAddressType(item) {
        this.changeValueAddressType = item;
        this._changeValueSet(true);
    }

    /**
     * country chanage will trigger state chagne
     * @param {*} item
     * @memberof ContactAddressComponent
     */
    changeValueCountry(item) {
        this.valueCountry = item;
        this.valueState = null;
        this._setStateData(item);
        this._changeValueSet(true);
    }

    /**
     * state change
     * @param {*} item
     * @memberof ContactAddressComponent
     */
    changeValueState(item) {
        this.valueState = item;
        this.hintContentState = '';
        this._changeValueSet(true);
    }

    /**
     * street change
     * @param {*} item
     * @memberof ContactAddressComponent
     */
    changeValueStreet(item) {
        this.valueStreet = item;
        this.hintContentStreet = '';
        this._changeValueSet(true);
    }

    /**
     * street2 change
     *
     * @param {*} item
     * @memberof ContactAddressComponent
     */
    changeValueStreet2(item) {
        this.valueStreet2 = item;
        this._changeValueSet(true);
    }

    /**
     * ctity change
     *
     * @param {*} item
     * @memberof ContactAddressComponent
     */
    changeValueCity(item) {
        this.valueCity = item;
        this.hintContentCity = '';
        this._changeValueSet(true);
    }

    /**
     * zip change
     *
     * @param {*} item
     * @memberof ContactAddressComponent
     */
    changeValueZip(item) {
        this.valueZip = item;
        this._changeValueSet(true);
    }

    clickSearchAddress() {
        this.isShowSearchAddress = !this.isShowSearchAddress;
        if (this.config.action === ContactTemplateType.EditContact) {
            let address = '';
            if (this.valueStreet2) {
                address = `${this.valueStreet2}`;
            }
            if (this.valueStreet) {
                address = `${address}${this.connector}${this.valueStreet}`;
            }
            if (this.valueCity) {
                address = `${address}${this.connector}${this.valueCity}`;
            }
            if (this.valueState) {
                address = `${address}${this.connector}${this.valueState}`;
            }
            if (this.valueZip) {
                address = `${address}${this.connector}${this.valueZip}`;
            }
            if (this.valueCountry) {
                address = `${address}${this.connector}${this.valueCountry}`;
            }
            this.mapConfig.inputValue = address.trim();
        } else {
            this.mapConfig.inputValue = this.valueStreet;
        }
    }

    filterChange(value) {
        if (!value) {
            this.valueStateList = this._valueStateList;
        } else {
            this.valueStateList = this._valueStateList.filter((s) => s && s.toLowerCase().indexOf(value.toLowerCase()) !== -1);
        }
        this.isCustom = false;
    }

    /**
     * set address from search
     * include tamale address and google address.
     * tamale address use contact webAddress.
     * google address judge by array length.
     *
     * @param {*} value
     * @memberof ContactAddressComponent
     */
    setSelectedAddress(value) {
        if (value.payload && value.payload.mapContactModel) {
            if (value.payload.mapContactModel.contact) {
                const contact: Contact = value.payload.mapContactModel.contact;
                const entityIndex = value.payload.mapContactModel.entityIndex;
                if (entityIndex > -1) {
                    this.valueCountry = contact.webAddress[entityIndex].country;
                    this._processCountry(this.valueCountry);
                    this.valueCity = contact.webAddress[entityIndex].city;
                    this._setStateData(this.valueCountry);
                    this.valueState = contact.webAddress[entityIndex].state;
                    this._processState();
                    this.valueStreet = contact.webAddress[entityIndex].street;
                    this.valueStreet2 = contact.webAddress[entityIndex].street2;
                    this.valueZip = contact.webAddress[entityIndex].zip;
                }
            } else {
                const googleAddress = value.payload.mapContactModel.selectedAddress;
                this._entityService.getAddress(googleAddress).pipe(
                    take(1),
                ).subscribe(contact => {
                    this.valueCountry = contact.country;
                    this._processCountry(this.valueCountry);
                    this._setStateData(this.valueCountry);
                    this.valueState = contact.state;
                    this._processState();
                    this.valueCity = contact.city;
                    this.valueStreet = contact.street;
                    this.valueStreet2 = contact.street2;
                    this.valueZip = contact.zip;
                    this._changeValueSet(true);
                },
                    error => {
                        this.valueStreet = googleAddress;
                        this._changeValueSet(true);
                    }
                );
            }
            this._changeValueSet(true);
        }
        this.isShowSearchAddress = false;
    }

    /**
     *init DropDown value
     *
     * @private
     * @memberof ContactAddressComponent
     */
    private _initData() {
        this.valueAddressTypeList = this.childConfig.dataSource.map(item => item.name);
        this.valueAddressType = this.config.defaultValue;
        this.valueCountryList = Array.from(new Set(DefaultWordCites.map(data => data.country).sort()));
        this.valueCountry = this.config.defaultValueCountry;
        this.valueState = null;
        this._setStateData(this.valueCountry);
        this._changeValueSet();
        this._destroySubscriptions.push(
            this._contactTemplateService.validInputSubject$.subscribe((res) => {
                if (this.config.prefixId === res.prefixId) {
                    if (!this.valueStreet && this.config.isRequired) {
                        this.hintContentStreet = businessConstants.tip;
                    }
                    if (!this.valueCity && this.config.isRequired) {
                        this.hintContentCity = businessConstants.tip;
                    }
                    if (!this.valueState && this.config.isRequired) {
                        this.hintContentState = businessConstants.tip;
                    }
                }
            }));
    }

    /**
     *
     * set edit data from staticValue
     * @private
     * @memberof ContactAddressComponent
     */
    private _initEditValue() {
        if (this.config.editValue) {
            this.isCustom = true;
            this.valueAddressType = this.config.editValue.name;
            this.valueCountry = this.config.editValue.country;
            this.valueStreet = this.config.editValue.street;
            this.valueStreet2 = this.config.editValue.street2;
            this.valueCity = this.config.editValue.city;
            this.valueState = this.config.editValue.state;
            this.valueZip = this.config.editValue.zip;
            this._processCountry(this.valueCountry);
            this._setStateData(this.valueCountry);
            this._processState();
            this._changeValueSet(true);
        }
    }

    /**
     * set State data by country change
     * @private
     * @param {*} item
     * @memberof ContactAddressComponent
     */
    private _setStateData(item) {
        const cityList = DefaultWordCites.filter(data => data.country === item);
        this.valueStateList = Array.from(new Set(cityList.map(data => data.subcountry).sort()));
        this.valueStateList.splice(0, 0, '');
        this._valueStateList = this.valueStateList;
        this._changeValueSet();
    }

    /**
     *
     * set value for store and changeValueSubject
     * @private
     * @memberof ContactAddressComponent
     */
    private _changeValueSet(isFromUser = false) {
        const addressValue = new AddressValue(this.valueAddressType, this.valueCountry, this.valueStreet, this.valueStreet2, this.valueCity, this.valueState, this.valueZip);
        const value = new ContactTemplateControlValue(addressValue, this.config.componentType,
            this.config, isFromUser);
        this._store.dispatch(
            new ChangeContactTemplateValueSet(
                value,
                'prefix',
                this.config.prefixId
            )
        );
    }

    /**
     *
     * country abbreviations
     * @private
     * @memberof ContactAddressComponent
     */
    private _processCountry(country: string) {
        this.isCustom = true;
        if (country) {
            // handle some special cases.
            const specialCountry = SpecialCountryList.find(item => item.name.toLowerCase() === country.toLowerCase());
            if (specialCountry) {
                this.valueCountry = specialCountry.country;
            } else {
                const countrySize = country.length;
                if (countrySize > 0) {
                    let index = -1;
                    switch (countrySize) {
                        case 2:
                            index = DefaultCountryList.findIndex(data => data.a2 === country.toUpperCase());
                            break;
                        case 3:
                            index = DefaultCountryList.findIndex(data => data.a3 === country.toUpperCase());
                            break;
                        default:
                            index = this.valueCountryList.findIndex(data => data.toLowerCase() === country.toLowerCase());
                            break;
                    }
                    if (index !== -1 && countrySize < 4) {
                        const normalCountry = DefaultCountryList[index].country;
                        this.valueCountry = normalCountry;
                    } else if (index !== -1 && countrySize >= 4) {
                        this.valueCountry = country;
                    } else {
                        if (this.config.street1 !== '') {
                            this.valueCountry = country;
                        } else {
                            this.valueCountry = '';
                        }
                    }
                }
            }
            this._changeValueSet(true);
        }

    }

    /**
     * state abbreviations
     *
     * @private
     * @memberof ContactAddressComponent
     */
    private _processState() {
        // due to old state include &nbsp not space .like 'New York' not equals 'New York'
        // convert to space.
        if (this.valueState) {
            const _state = decodeURI(encodeURI(this.valueState).replace(/%C2%A0/g, '%20'));
            if (_state) {
                if (_state.length === 2) {
                    const index = DefaultStateList.findIndex(data => data.a2 === _state.toUpperCase());
                    if (index !== -1) {
                        // Abbreviations convert to full name.
                        const normalState = DefaultStateList[index].state;
                        const selectItemIndex = this.valueStateList.findIndex(item => item.toLowerCase() === normalState.toLowerCase());
                        if (selectItemIndex > -1) {
                            this.valueState = this.valueStateList[selectItemIndex];
                        }
                    } else {
                        if ((this.config && this.config.editValue && this.config.editValue.street && this.config.editValue.street !== '') || this.config.action === ContactTemplateType.NewContact) {
                            this.valueState = _state;
                        } else {
                            this.valueState = '';
                        }
                    }
                    this._changeValueSet(true);
                } else {
                    const index = this.valueStateList.findIndex(data => data.toLowerCase() === _state.toLowerCase());
                    if (index !== -1) {
                        this.valueState = _state;
                    } else {
                        // support convert state for search address in new contact mode.
                        if ((this.config && this.config.editValue && this.config.editValue.street && this.config.editValue.street !== '') || this.config.action === ContactTemplateType.NewContact) {
                            this.valueState = _state;
                        } else {
                            this.valueState = '';
                        }
                    }
                    this._changeValueSet(true);
                }
            }
        }
    }
}

